//jQuery
//import jQuery from 'jquery'

//Bootstrap
import 'bootstrap/js/src/alert'
import 'bootstrap/js/src/collapse'

//Wirebox core
import EventBus from '../../shared/js/wirebox/event-bus'

//Wirebox utilities
import '../../shared/js/wirebox/utilities/dynamic-inputs'

//Wirebox components
import '../../shared/js/wirebox/components/csrf-token'

//Shared components
import '../../shared/js/components/confirmation'
import '../../shared/js/components/form-validation'

//Components
import './components/stripe-form'

//Modules
import './modules/forms/discount'
import './modules/forms/plan-select'
import './modules/modals/cancel-reason'
import './modules/payment-submit-btn'

//Run modules
EventBus.run()